import WsTable from './table.vue'

export default WsTable
